import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import CapitalGainsTaxRateInput from '../capital-gains-tax-rate';

const CapitalGainsTaxRateInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <CapitalGainsTaxRateInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default CapitalGainsTaxRateInputWithAnalytics;
